import _ from 'lodash';
import React from 'react';
import { inject, observer } from 'mobx-react';
import ItemOptions from './item-options';
import autobind from 'autobind-decorator';

@inject('songsStore', 'playlistStore', 'artistStore')
@observer
class HFMPicksItem extends React.Component {

	render () {

		const { artist, artwork, song } = this.props;

		console.log(this.props);
		return (
			<div className="grid-x margin-left-3 margin-bottom-2 new-releases-item" >
				<div className="cell shrink">
					<div
						onClick={this.playSong}
						className="new-releases-tile"
						style={
							{
								// backgroundImage: `url("/artist/assets/public/s3/img/${artwork}")`
								backgroundImage: `url(${artwork})`
							}
						}
					>
						<i className="player-tile-icon fa fa-fw fa-play nr-fade-icon"></i>
					</div>
				</div>
				<div className="margin-left-1 cell auto">
					<div className="new-release-info">
						<div>
							<div className="title"> {  song.title   }</div>
							<div className="artist">{ artist }</div>
						</div>
						<div className="item-options-button">
							<ItemOptions
								song={song}
								artist={artist}
							/>
						</div>
					</div>
					
					
				</div>
			</div>
		);
	}

	@autobind
	playSong () {
		const { playlistStore, song } = this.props;
		playlistStore.setCurrentPlaylist([song]);

	}
}

@inject('playlistStore', 'songsStore', 'artistStore')
@observer
class HFMPicks extends React.Component {
	render() {
		const { playlistStore, songsStore, artistStore } = this.props;
		let newReleases = playlistStore.items.find(p=>p.listType === 'NEW_RELEASES');
		console.log(newReleases)

		if (playlistStore.isLoading || songsStore.isLoading) {

			return (<h1>Loading...</h1>);
		}


		if(_.isEmpty(newReleases) || newReleases === undefined || _.isEmpty(artistStore.items)) {
			return null;
		}

		return (
			<div>
				<h3 className="section-title padding-bottom-1">{newReleases.title}</h3>
					<div className="new-releases-grid grid-x">
						{
							
							newReleases.songs.map((s, idx) => {
								console.log(s);
								const artist = artistStore.items.find(artist=> artist.id === s.artistID);
								return (
									<HFMPicksItem
										artist={ artist?.name }
										artwork={ s.artwork || artist?.imagePath }
										song={ s }
										key={`nr-${idx}`}
										/>
								)
							})
						}
					</div>
			</div>
		);
	}
}

export default HFMPicks;
